import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import salesApiClient from 'api/salesApiClient';
import Button from 'common-ui/button';
import Modal from 'common-ui/modal';
import { TypeToSearchSelect } from 'common-ui/select';
import { attachVivaProcess } from 'features/newsales/newsalesActions';

import { ModalActions } from '../../../salesLead/components/Components.styles';

const AttachVivaRequestModal = ({ isOpen, onClose, onConfirm, leadId }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setSelected(null);
    }
  }, [isOpen]);

  const fetchVivaRequestOptions = async (searchTerm) => {
    try {
      const trimmedTerm = searchTerm?.trim();
      if (!trimmedTerm) return [];

      const response = await salesApiClient.get(
        `leads/viva-process/by-phone/${encodeURIComponent(trimmedTerm)}`
      );
      if (!response?.processId) return [];

      return [{ value: response.processId, label: String(response.processId) }];
    } catch (error) {
      console.error('Error fetching viva process:', error);
      return [];
    }
  };

  const handleConfirm = async () => {
    if (!selected) return;
    setLoading(true);
    try {
      await dispatch(attachVivaProcess({ leadId, processId: selected.value })).unwrap();
      onConfirm(selected);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Attach Viva Request"
      closeIcon
      footer={false}
    >
      <TypeToSearchSelect
        label="Select Viva Request"
        placeholder="Type mobile number to search..."
        value={selected}
        onChange={setSelected}
        loadOptions={fetchVivaRequestOptions}
        debounceDelay={500}
        isClearable
      />
      <ModalActions>
        <Button outlined onClick={onClose} type="button">
          Cancel
        </Button>
        <Button
          secondary
          onClick={handleConfirm}
          disabled={!selected || loading}
          isLoading={loading}
        >
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default AttachVivaRequestModal;
